import React from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import Touchable from '../Touchable';
import BodyText from '../BodyText';
import type { BodyText as BodyTextType } from '..';

const TypedBodyText = BodyText as typeof BodyTextType;

const CheckButton = ({
  testID, checked, onClick, children,
}: {
  testID: string;
  checked: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <Touchable
    testID={testID}
    onClick={onClick}
  >
    <Box
      padding={8}
      color={checked ? BrandColor.LightBlue : BrandColor.WhiteWash}
      borderWidth={2}
      borderColor={BrandColor.BackInBlack}
    >
      <TypedBodyText textTransform="uppercase" weight="bold">{children}</TypedBodyText>
    </Box>
  </Touchable>
);
export default CheckButton;
